module.exports = __webpack_public_path__ + "static/media/target4_1.3f61fcf2.png";